import script from "./AppColorInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppColorInput.vue?vue&type=script&lang=ts&setup=true"

import "./AppColorInput.vue?vue&type=style&index=0&id=f9d14afc&lang=css"

const __exports__ = script;

export default __exports__